// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"35e9f4ab","498":"9e4d5d8f","513":"61b0dc01","703":"56d7e282"}[chunkId] + ".chunk.js";
};